import "../../../../src/content/european-congress-lp/congress.scss";
import EuropeanCongressHeader from "../../../../src/content/european-congress-lp/european-congress-header.mdx";
import EuropeanCongressSection from "../../../../src/content/european-congress-lp/european-congress-section.md";
import * as React from 'react';
export default {
  EuropeanCongressHeader,
  EuropeanCongressSection,
  React
};